var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"app-main"},[_c('el-main',{staticClass:"main-container",style:(_vm.mainStyle)},[_c('el-scrollbar',{ref:"scrollbar"},[_vm._t("main")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }